<template>
    <div>
        <slot name="regions"></slot>
        <slot name="questions"></slot>
        <slot name="terms"></slot>

        <div class="_dflex-block _align-items-center _mt-32-24">
            <d-select
                static-label="Регион покупки"
                :items="regionsTitles"
                v-model="region"
                class="_w-320 _mr-32-0"
            />

            <div class="switch switch-black">
                <div class="switch__container">
                    <div class="switch__item">
                        <input v-model="regionSwitcher" type="radio" id="table-1" value="conditions" checked>
                        <label class="switch__label" for="table-1">
                            <span>Условия</span>
                        </label>
                    </div>
                    <div class="switch__item">
                        <input v-model="regionSwitcher" type="radio" id="table-2" value="terms">
                        <label class="switch__label" for="table-2">
                            <span>Требования</span>
                        </label>
                    </div>
                    <div class="switch__item">
                        <input v-model="regionSwitcher" type="radio" id="table-4" value="questions">
                        <label class="switch__label" for="table-4">
                            <span>Частые вопросы</span>
                        </label>
                    </div>
                    <div class="switch__item">
                        <input v-model="regionSwitcher" type="radio" id="table-3" value="documents">
                        <label class="switch__label" for="table-3">
                            <span>Документы</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="_mt-40-24">
            <div v-if="regionSwitcher === 'conditions'">
                <h3 class="h3">Условия</h3>
                <div class="_mt-40-24">
                    <accordeon-seo v-for="(item, index) in content" :key="index" :title="item.attributes.title.value">
                        <div v-html="item.innerHTML"></div>
                    </accordeon-seo>
                </div>
            </div>

            <div v-if="regionSwitcher === 'terms'">
                <h3 class="h3">Требования</h3>
                <div class="_mt-40-24">
                    <accordeon-seo v-for="(item, index) in termsContent" :key="index" :title="item.attributes.title.value">
                        <div v-html="item.innerHTML"></div>
                    </accordeon-seo>
                </div>
            </div>

            <div v-if="regionSwitcher === 'questions'">
                <h3 class="h3">Частые вопросы</h3>
                <div class="_mt-40-24">
                    <accordeon-seo v-for="(item, index) in questionsContent" :key="index" :title="item.attributes.title.value">
                        <div v-html="item.innerHTML"></div>
                    </accordeon-seo>
                </div>
            </div>
            <div v-if="regionSwitcher === 'documents'">
                <h3 class="h3">Документы</h3>
                <div class="_mt-40-24">
                    <slot name="documents"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MortgageRegions",
        data() {
            return {
                regionsTitles: [],
                regionsData: '',
                termsData: '',
                questionsData: '',
                region: '',
                regionSwitcher: 'conditions',
                content: '',
                termsContent: '',
                questionsContent: '',
            }
        },
        methods: {
            getRegionsTitles() {
                this.regionsData.querySelectorAll('.regions-block').forEach((val, index) => {
                    if (index === 0) this.region = val.getAttribute('data-name')
                    this.regionsTitles.push( { const: val.getAttribute('data-name'), title: val.getAttribute('data-name') } );
                })
            },
            getContent() {
                this.regionsData.querySelectorAll('.regions-block').forEach((val) => {
                    if (val.getAttribute('data-name') === this.region) {
                        this.content = [...val.querySelectorAll('accordeon')];
                    }
                })
            },
            getTerms() {
                this.termsData.querySelectorAll('.regions-requirements-block').forEach((val) => {
                    if (val.getAttribute('data-name') === this.region.trim()) {
                        this.termsContent = [...val.querySelectorAll('accordeon')];
                    }
                })
            },
            getQuestions() {
                this.questionsData.querySelectorAll('.regions-questions-block').forEach((val) => {
                    if (val.getAttribute('data-name') === this.region) {
                        this.questionsContent = [...val.querySelectorAll('accordeon')];
                    }
                })
            }
        },
        watch: {
            region() {
                this.getContent();
                this.getTerms();
                this.getQuestions();
            }
        },
        beforeMount() {
            this.regionsData = document.getElementById('regions');
            this.termsData = document.getElementById('terms');
            this.questionsData = document.getElementById('questions');
            this.getRegionsTitles();
            this.getContent();
            this.getTerms();
            this.getQuestions();
        }
    }
</script>
